import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './negative.module.scss';

const METADATA = Metadata.define({
  description: 'Primary negative badge indicator.',
  name: 'Negative Primary Badge',
});

export default class SpdsIndicatorBadgeNegativePrimary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  variantClass = 'spds-indicator-badge-negative';
  variantStyles = styles;
}

export const BADGE_NEGATIVE_PRIMARY_METADATA = SpdsIndicatorBadgeNegativePrimary.metadata;
